import { Facebook, Instagram, Twitter, Linkedin, ChefHat } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const quickLinks = [
    { label: "Corporate Catering", id: "corporate" },
    { label: "Events & Celebrations", id: "events" },
    { label: "Appetizers", id: "appetizers" },
    { label: "Our Menus", id: "menus" },
    { label: "About Us", id: "about" },
    { label: "Gallery", id: "gallery" },
    { label: "Request a Quote", id: "contact" }
  ];

  const socialLinks = [
    { icon: Facebook, href: "#", label: "Facebook" },
    { icon: Instagram, href: "#", label: "Instagram" },
    { icon: Twitter, href: "#", label: "Twitter" },
    { icon: Linkedin, href: "#", label: "LinkedIn" }
  ];

  return (
    <footer className="bg-gray-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center gap-2">
              <ChefHat className="w-8 h-8 text-orange-500" />
              <span className="font-heading text-2xl font-bold">Kamaliicious</span>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-md">
              Thoughtfully cooked. Professionally served. We bring warmth, organization, and exceptional flavor to corporate events, intimate gatherings, and large-scale celebrations.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-10 h-10 rounded-full bg-gray-800 hover:bg-orange-700 flex items-center justify-center transition-colors duration-300"
                  aria-label={social.label}
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h3 className="font-semibold text-lg">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-orange-500 transition-colors duration-200"
                    data-testid={`footer-link-${link.id}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="font-semibold text-lg">Contact Us</h3>
            <ul className="space-y-3 text-gray-400">
              <li>
                <span className="block text-sm text-gray-500">Phone</span>
                301-412-5210
              </li>
              <li>
                <span className="block text-sm text-gray-500">Email</span>
                kamaliicious15@gmail.com
              </li>
              <li>
                <span className="block text-sm text-gray-500">Service Area</span>
                Greater Metro Area
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Kamaliicious. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm font-accent italic">
            "Food that brings people together"
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
